export const ORGANISATION = (id?: string) => {
  if (id) {
    return `base/organizations/${id}?include=organizationType,orgConfig,platformOrgConfig`;
  }
  return `base/organizations`;
};

export const GET_USER_DETAILS = (organisationId: string) => {
  return `base/organizations/${organisationId}/users/details`;
};
